/**
 * Normalize any input date string (ISO timestamps, M/D/YYYY, YYYY-MM-DD)
 * into the standard YYYY-MM-DD format required by HTML5 date inputs.
 */
export function normalizeDate(d: string | Date | null | undefined): string {
  if (!d) return '';
  if (d instanceof Date) {
    return d.toISOString().slice(0, 10);
  }
  const s = String(d).trim();
  if (!s) return '';

  // 1. Match YYYY-MM-DD (e.g. 2026-08-06T00:00:00.000Z or 2026-08-06)
  const ymdMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (ymdMatch) {
    return `${ymdMatch[1]}-${ymdMatch[2]}-${ymdMatch[3]}`;
  }

  // 2. Match M/D/YYYY or MM/DD/YYYY (e.g. 6/22/2026 or 06/22/2026)
  const mdyMatch = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(s);
  if (mdyMatch) {
    const month = (mdyMatch[1] ?? '').padStart(2, '0');
    const day = (mdyMatch[2] ?? '').padStart(2, '0');
    const year = mdyMatch[3] ?? '';
    return `${year}-${month}-${day}`;
  }

  // 3. Fallback using native JS Date parsing
  try {
    const parsed = new Date(s);
    if (!isNaN(parsed.getTime())) {
      const y = parsed.getFullYear();
      const m = String(parsed.getMonth() + 1).padStart(2, '0');
      const day = String(parsed.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    }
  } catch {
    // Return original string if parsing fails
  }
  return s;
}
